<div class="bubble-container">
  <mat-icon class="error-icon" *ngIf="['failed', 'undelivered'].includes(messageStatus!)">error</mat-icon>
  <div #bubbleElement class="bubble" [ngClass]="itemContent === 'message' ? 'content-message' : 'content-attachment'">
    <ng-container [ngSwitch]="isTyping">
      <ng-container *ngSwitchDefault>
        <!--  -->

        <ng-content></ng-content>

        <!--  -->
      </ng-container>
      <ng-container *ngSwitchCase="true">
        <!--  -->

        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>

        <!--  -->
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="metadata" [class.show]="isMetadataPresented">
  <ng-content select="glxy-additional-metadata"></ng-content>
  <span class="message-status-time">
    <span *ngIf="messageStatusText" class="message-status">{{ messageStatusText | translate }}</span>
    <span *ngIf="messageTime" class="message-time">{{ messageTime }}</span>
  </span>
</div>
